import { get, patch, post } from "./api";
import {
  IUserBusinessDto,
  ICreateBusinessDto,
  IUserDto,
  IUserListDto,
  IUserFiltersDto,
} from "../interfaces/dto/user.dto";
import { IUserUpdate } from "../interfaces/user";
import { APIUrl } from "../config/api-url.config";
import { ICreateBusiness } from "../interfaces/user";

export const getBusiness = (userId: string, token: string) =>
  get<{ userId: string }, IUserBusinessDto>(
    APIUrl.allBusiness,
    { userId },
    token,
  );

export const createBusiness = (userId: string, payload: ICreateBusiness) =>
  post<ICreateBusiness, ICreateBusinessDto>(
    APIUrl.businesses(userId),
    payload,
    undefined,
  );

export const getUserInfo = (userId: string, token: string) =>
  get<undefined, IUserDto>(APIUrl.user(userId), undefined, token);

export const updateBusiness = (
  userId: string,
  bussinessId: string,
  payload: ICreateBusiness,
  token: string,
) =>
  patch<ICreateBusiness, IUserBusinessDto>(
    APIUrl.business(userId, bussinessId),
    payload,
    undefined,
    token,
  );

export const updateUserInfo = (
  userId: string,
  payload: IUserUpdate,
  token: string,
) =>
  patch<IUserUpdate, IUserDto>(APIUrl.user(userId), payload, undefined, token);

export const getUsers = (filters: IUserFiltersDto, token: string) =>
  get<IUserFiltersDto, IUserListDto>(APIUrl.users, filters, token);
